export function formatPrice(price: number | string): string {
  if (typeof price == 'string') return price;
  let isNegative = price < 0;
  price = Math.abs(price);
  let pstring = '';
  while (price > 999) {
    pstring = (price % 1000).toString().padStart(3, '0') + ' ' + pstring;
    // @ts-ignore
    price = Math.floor(price / 1000);
  }
  pstring = price + ' ' + pstring;
  if (isNegative) pstring = '-' + pstring;
  return pstring;
}
